import { MouseEventHandler } from 'react';

import TextBaseFieldPlaceholder, {
  TextBaseFieldPlaceholderProps,
} from '@app/features/apply-react-signing/components/FieldSetupStep/Placeholders/TextBaseFieldPlaceholder';

export interface DateFieldPlaceholderProps extends Omit<TextBaseFieldPlaceholderProps, 'value'> {
  dateFormat: string;
}

const defaultProps = {
  rootElementSize: null,
  onMouseDown(_event: MouseEventHandler<HTMLDivElement>) {},
};

function DateFieldPlaceholder({ dateFormat, ...props }: DateFieldPlaceholderProps) {
  return <TextBaseFieldPlaceholder {...props} value={dateFormat} />;
}

DateFieldPlaceholder.defaultProps = defaultProps;

export default DateFieldPlaceholder;
